module.exports = __webpack_public_path__ + "static/media/CostSaving.b9017987.svg";